import styled from "styled-components"

export default {
    "Wrapper": styled.main`
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `,
    "ContentDiv": styled.div`
        width: fit-content;
        height: fit-content;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 80px;
        background-color: ${({ theme }) => theme.color.white};
        border-radius: 20px;
        padding: 96px 64px;

        & > h2 {
            ${({ theme }) => theme.font.large_bold}
        }
    `,

    "FormDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 32px;
        width: 432px;
        background-color: ${({ theme }) => theme.color.white};
    `,
    "InputDiv": styled.main`
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;

        & > h2 {
            ${({ theme }) => theme.font.medium_bold};

            & > span {
                color: ${({ theme }) => theme.color.major};
            }
        }

        & > input {
            padding-bottom: 12px;
            ${({ theme }) => theme.font.small};
            border-bottom: 1px solid ${({ theme }) => theme.color.grey3};
            
            &::placeholder {
                color: ${({ theme }) => theme.color.grey3};
            }
        }
    `,
    "BtnDiv": styled.div`
        display: flex;
        flex-direction: column;
        align-items: end;
        gap: 12px;
    `,
}